import { useEffect, useState } from "react";
import api from "@/lib/api";

/** Fetches editable option lists from /api/settings and returns them.
 *  Each page can safely fall back to defaults while the settings load. */
export function useLists() {
  const [lists, setLists] = useState({});
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/settings").then(({ data }) => {
      if (!alive) return;
      setSettings(data);
      setLists(data.lists || {});
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return { lists, settings };
}
